import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import TextInput from './TextInput';

const LinkableTextInput = ({ to, ...rest }) => (
  <Link to={to}>
    <TextInput linkable {...rest} />
  </Link>
);

LinkableTextInput.propTypes = {
  to: PropTypes.string
};

export default LinkableTextInput;
